<template>
  <div class="terms-page">
    <div class="terms-container">
      <div class="terms-header">
        <h1>用户服务协议</h1>
        <p class="effective-date">生效日期：2026年5月10日</p>
        <p class="parties">甲方：贵州省韦小布文艺创作工作室（韦小布AI）</p>
        <p class="parties">乙方：用户</p>
      </div>
      <div class="terms-content">
        <section class="term-section">
          <h2>一、协议接受</h2>
          <p>1.1 本协议是贵州省韦小布文艺创作工作室（以下简称"甲方"或"韦小布AI"）与用户（以下简称"乙方"或"用户"）之间关于使用韦小布AI平台所提供的各项服务所达成的协议。</p>
          <p>1.2 乙方在注册、登录或使用韦小布AI平台服务之前，应当仔细阅读本协议的全部条款。一旦乙方完成注册流程或开始使用本平台服务，即视为乙方已充分理解并同意接受本协议的所有条款。</p>
          <p>1.3 甲方有权根据需要不时修订本协议，修订后的协议将在平台上公布。乙方继续使用本平台服务的，视为已接受修订后的协议。如乙方不同意修订后的协议，应立即停止使用本平台服务。</p>
        </section>

        <section class="term-section">
          <h2>二、服务说明</h2>
          <p>2.1 韦小布AI平台提供以下服务：</p>
          <ul>
            <li>AI文案创作服务（文案改进、总结报告等）</li>
            <li>AI图片生成服务（文本生成图片、图片编辑等）</li>
            <li>AI视频生成服务</li>
            <li>AI短剧创作服务</li>
            <li>其他甲方可能推出的AI相关服务</li>
          </ul>
          <p>2.2 甲方保留随时修改、中断或终止部分或全部服务的权利，无需事先通知乙方。</p>
          <p>2.3 乙方理解并同意，AI生成内容存在不确定性，甲方不保证生成结果的准确性、完整性或适用性。</p>
        </section>

        <section class="term-section">
          <h2>三、账号注册与使用</h2>
          <p>3.1 乙方注册时需提供真实、准确的个人信息。如信息发生变更，乙方应及时更新。</p>
          <p>3.2 乙方对其账号及密码的安全性负全部责任。因乙方保管不善导致的任何损失，甲方不承担责任。</p>
          <p>3.3 乙方不得将账号转让、出借或出租给第三方使用。</p>
          <p>3.4 乙方在使用服务过程中，不得进行以下行为：</p>
          <ul>
            <li>利用本平台生成侵犯他人肖像权、名誉权、隐私权等合法权益的内容</li>
            <li>生成违反国家法律法规的内容，包括但不限于色情、暴力、恐怖、反动等信息</li>
            <li>利用本平台生成虚假信息、谣言或误导性内容</li>
            <li>利用本平台从事任何违法活动</li>
            <li>利用本平台服务进行深度伪造（Deepfake）等侵害他人权益的行为</li>
            <li>其他违反法律法规或本协议约定的行为</li>
          </ul>
        </section>

        <section class="term-section">
          <h2>四、AI生成内容的权利归属</h2>
          <p>4.1 乙方使用本平台服务所生成的内容，其知识产权归乙方所有，但乙方应确保生成内容不侵犯任何第三方的合法权益。</p>
          <p>4.2 纯AI生成的内容根据现行《著作权法》可能不构成受著作权法保护的作品。乙方理解并同意此法律风险。</p>
          <p>4.3 甲方保留对乙方生成内容进行安全审核的权利。如发现违规内容，甲方有权删除相关内容并暂停或终止乙方的服务。</p>
        </section>

        <section class="term-section">
          <h2>五、AI内容标识与合规</h2>
          <p>5.1 根据《人工智能生成合成内容标识办法》（自2025年9月1日起施行）的规定，乙方在使用本平台服务生成的AI内容，应当遵守相关标识要求。</p>
          <p>5.2 甲方生成的AI图片、视频等内容将自动添加AI生成标识，乙方不得移除、篡改该标识。</p>
          <p>5.3 乙方在使用AI生成内容时，应当以适当方式标注内容为AI生成，确保信息透明度。</p>
        </section>

        <section class="term-section">
          <h2>六、用户个人信息保护</h2>
          <p>6.1 甲方将按照《中华人民共和国个人信息保护法》的规定，依法收集、使用和保护乙方的个人信息。</p>
          <p>6.2 甲方收集的个人信息仅用于提供服务、改进服务质量和保障服务安全。</p>
          <p>6.3 未经乙方同意，甲方不会向第三方泄露乙方的个人信息，法律法规另有规定的除外。</p>
          <p>6.4 甲方将采取合理的安全措施保护乙方的个人信息不被未授权访问、使用、披露或篡改。</p>
        </section>

        <section class="term-section">
          <h2>七、免责声明</h2>
          <p>7.1 甲方提供的服务按"现状"提供，甲方不对服务的及时性、安全性、准确性作出任何明示或暗示的保证。</p>
          <p>7.2 甲方不对因不可抗力、技术故障、网络中断等非甲方可控制因素导致的服务中断承担责任。</p>
          <p>7.3 乙方使用AI生成内容产生的任何后果由乙方自行承担，甲方不对生成内容的准确性、合法性负责。</p>
          <p>7.4 乙方因使用或无法使用本平台服务所导致的任何间接、附带、特殊或后果性损失，甲方不承担赔偿责任。</p>
        </section>

        <section class="term-section">
          <h2>八、服务终止</h2>
          <p>8.1 甲方有权在以下情形下终止向乙方提供服务：</p>
          <ul>
            <li>乙方违反本协议的任何条款</li>
            <li>乙方利用本平台从事违法活动</li>
            <li>根据法律法规或政府部门的要求</li>
            <li>甲方认为有必要终止服务的其他情形</li>
          </ul>
          <p>8.2 服务终止后，乙方已支付但未使用的服务费用，甲方将根据实际情况进行处理。</p>
          <p>8.3 乙方有权随时申请注销账号，甲方将在合理时间内处理。</p>
        </section>

        <section class="term-section">
          <h2>九、争议解决</h2>
          <p>9.1 本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。</p>
          <p>9.2 因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决。协商不成的，任何一方均可向甲方所在地有管辖权的人民法院提起诉讼。</p>
        </section>

        <section class="term-section">
          <h2>十、其他条款</h2>
          <p>10.1 本协议构成双方就本协议主题事项所达成的完整协议，取代双方此前就相关事项达成的所有口头或书面协议。</p>
          <p>10.2 本协议任何条款被认定为无效或不可执行，不影响其他条款的效力。</p>
          <p>10.3 甲方未能行使本协议项下的任何权利，不构成对该权利的放弃。</p>
          <p>10.4 本协议中使用的标题仅为方便阅读而设，不影响本协议的解释。</p>
        </section>

        <section class="term-section">
          <h2>十一、联系方式</h2>
          <p>如乙方对本协议有任何疑问或需要帮助，请通过以下方式联系甲方：</p>
          <ul>
            <li>平台名称：韦小布AI</li>
            <li>运营主体：贵州省韦小布文艺创作工作室</li>
          </ul>
        </section>

        <div class="terms-footer">
          <p class="last-updated">最后更新日期：2026年5月10日</p>
          <p class="copyright">© 2026 韦小布AI - 贵州省韦小布文艺创作工作室 版权所有</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style scoped>
.terms-page {
  min-height: 100vh;
  background: #0a0e1a;
  padding: 40px 20px;
}

.terms-container {
  max-width: 900px;
  margin: 0 auto;
  background: #111827;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
  border: 1px solid #1e293b;
}

.terms-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid #00d4aa;
}

.terms-header h1 {
  font-size: 32px;
  color: #00d4aa;
  margin: 0 0 16px 0;
  font-weight: 700;
}

.effective-date {
  color: #94a3b8;
  font-size: 14px;
  margin: 0 0 8px 0;
}

.parties {
  color: #cbd5e1;
  font-size: 15px;
  margin: 4px 0;
}

.terms-content {
  color: #e2e8f0;
  line-height: 1.8;
}

.term-section {
  margin-bottom: 32px;
}

.term-section h2 {
  font-size: 20px;
  color: #00d4aa;
  margin: 0 0 16px 0;
  padding-left: 12px;
  border-left: 3px solid #00d4aa;
}

.term-section p {
  margin: 8px 0;
  color: #cbd5e1;
  font-size: 14px;
}

.term-section ul {
  margin: 8px 0 8px 20px;
  padding: 0;
}

.term-section ul li {
  color: #cbd5e1;
  font-size: 14px;
  margin: 6px 0;
  list-style: disc;
}

.terms-footer {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #1e293b;
  text-align: center;
}

.last-updated {
  color: #94a3b8;
  font-size: 13px;
  margin: 0 0 8px 0;
}

.copyright {
  color: #64748b;
  font-size: 13px;
  margin: 0;
}

@media (max-width: 768px) {
  .terms-page {
    padding: 20px 10px;
  }

  .terms-container {
    padding: 24px 16px;
  }

  .terms-header h1 {
    font-size: 24px;
  }

  .term-section h2 {
    font-size: 17px;
  }

  .term-section p,
  .term-section ul li {
    font-size: 13px;
  }
}
</style>
